import { render, staticRenderFns } from "./MatchDetails.vue?vue&type=template&id=6e241591&"
import script from "./MatchDetails.vue?vue&type=script&lang=js&"
export * from "./MatchDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports